import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Layout } from "../components/Layout";
import { Gallery } from "../components/gallery";
import { useSEO } from "../hooks/useSEO";

export const GalleryPage = ({ data }) => {
  useSEO({
    title: "Operations Gallery | Transwave Shipping & Logistics Dubai",
    description:
      "See Transwave Shipping's operations in action — container loading, sea freight, cargo handling, warehouse management, and international logistics coordination in Dubai, UAE.",
    canonical: "https://www.transwaveshipping.com/gallery",
  });

  return (
    <Layout contactData={data.Contact}>
      {/* Page Hero — full-bleed, title pinned bottom-left */}
      <div className="page-hero page-hero--gallery">
        <div className="container">
          <motion.div
            className="page-hero-bottom-left"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
          >
            <h1>Our Operations</h1>
            <p>A look at our cargo handling, freight coordination, and logistics operations</p>
            <nav className="page-breadcrumb" aria-label="breadcrumb">
              <Link to="/">Home</Link> <span>/</span> <span>Gallery</span>
            </nav>
          </motion.div>
        </div>
      </div>

      <Gallery data={data.Gallery} />

      {/* CTA */}
      <div className="page-cta">
        <div className="container text-center">
          <h3>Let us handle your next shipment</h3>
          <p>Professional cargo handling and freight forwarding across sea, air and road.</p>
          <Link to="/contact" className="btn btn-custom btn-lg">Get a Free Quote</Link>
        </div>
      </div>
    </Layout>
  );
};
